export class SecureDocModel {
    constructor() { }

    ID: string;
    FileID: string;
    DocumentName: string;
    Recipients: string[];
    CompletionPercentage: number;
    UpdatedAt: string;
}

export const mapToSecureDoc = (x: any): SecureDocModel => {
    return {
        ID: x.id,
        FileID: x.file_id,
        DocumentName: x.document_name,
        Recipients: x.recipients,
        CompletionPercentage: x.completion_percent,
        UpdatedAt: x.updated_at,
    } as SecureDocModel;
}

export class SecureDocUpdateInfoModel {
    constructor() { }

    ID: string;
    CreatedAt: string;
    UpdatedAt: string;
    FileList: {
        FileID: string;
        FileName: string;
        FileType: string;
        IsCompleted?: boolean;
        URL?: string;
    }[];
    Message: string;
    Recipients: {
        Email: string;
        IsCompleted: boolean;
        IsInviteSent: boolean;
        Name: string;
        OrderNumber: number;
        PhoneNumber: string;
        RecipientID: string;
        Type: string;
        OTPInfo: {
            OTP: string;
            ExpiresAt: string;
        };
    }[];
    Settings: {
        IsPasswordProtected: boolean;
        Password: string;
        ReminderCount: number;
    };
    Status: number;
    UserID: string;
    UserName: string;
    CompleteInOrder: boolean;
}

export const mapToSecureDocUpdateInfo = (x: any): SecureDocUpdateInfoModel => {
    return {
        ID: x.id,
        CreatedAt: x.created_at,
        UpdatedAt: x.updated_at,
        FileList: x.files?.map((file: any) => ({
            FileID: file.file_id,
            FileName: file.file_name,
            FileType: file.file_type,
            IsCompleted: file.is_completed,
            URL: file.value,
        })),
        Message: x.message,
        Recipients: x.recipients?.map((r: any) => ({
            Email: r.email,
            IsCompleted: r.is_completed,
            IsInviteSent: r.is_invite_sent,
            Name: r.name,
            OrderNumber: r.order_number,
            PhoneNumber: r.phone_number,
            RecipientID: r.recipient_id,
            Type: r.type,
            OTPInfo: {
                OTP: r.otpinfo?.otp,
                ExpiresAt: r.otpinfo?.expires_at,
            }
        })),
        Settings: {
            IsPasswordProtected: x.settings?.password_protect,
            Password: x.settings?.password,
            ReminderCount: x.settings?.reminder,
        },
        Status: x.status,
        UserID: x.user_id,
        UserName: x.user_name,
        CompleteInOrder: x.complete_in_order,
    } as SecureDocUpdateInfoModel;
};

export class AddSecureDocModel {
    constructor() { }

    ID: string;
    FileList: {
        FileID: string;
        FileName: string;
        FileType: string;
    }[];
    Message: string;
    Recipients: {
        Email: string;
        Name: string;
        OrderNumber: number;
        PhoneNumber: string;
        RecipientID: string;
        Type: string;
    }[];
    Settings: {
        IsPasswordProtected: boolean;
        Password: string;
        ReminderCount: number;
    };
    UserID: string;
    CompleteInOrder: boolean;
}

export const mapToAddSecureDoc = (x: any): AddSecureDocModel => {
    return {
        ID: x.id,
        FileList: x.files?.map((file: any) => ({
            FileID: file.file_id,
            FileName: file.file_name,
            FileType: file.file_type,
        })),
        Message: x.message,
        Recipients: x.recipients?.map((r: any) => ({
            Email: r.email,
            Name: r.name,
            OrderNumber: r.order_number,
            PhoneNumber: r.phone_number,
            RecipientID: r.recipient_id,
            Type: r.type,
        })),
        Settings: {
            IsPasswordProtected: x.settings?.password_protect,
            Password: x.settings?.password,
            ReminderCount: x.settings?.reminder,
        },
        UserID: x.user_id,
        CompleteInOrder: x.complete_in_order,
    } as SecureDocUpdateInfoModel;
};
